<app-header></app-header>
<app-menu></app-menu>
<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row" style="top: 80px">
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row">
    <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5 col-xxl-5 row">
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
        <mat-form-field appearance="fill">
          <mat-label>Company name</mat-label>
          <mat-select [(value)]="selected" [disabled]="tab3">
            <mat-option *ngFor="let datos of Customer" [value]="datos.key">{{
              datos.value
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
        <mat-form-field appearance="fill">
          <mat-label style="text-transform: none !important;">Type of Report</mat-label>
          <mat-select
            [(value)]="selected2"
            (selectionChange)="OnHtmlTypeReports($event.value)"
          >
            <mat-option *ngFor="let datos of typeReport" [value]="datos">{{
              datos.reports
            }}</mat-option>
            <mat-option [value]="dataReportType">{{dataReportType.reports}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="col-xs-7 col-sm-7 col-md-7 col-lg-7 col-xl-7 col-xxl-7 row" *ngIf="htmlDate">
      <mat-form-field appearance="fill" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3" *ngIf="SearchIn">
        <mat-label>Search</mat-label>
        <input matInput [(ngModel)]="Searchtxt" [(value)]="Searchtxt" #Sear>
      </mat-form-field>
      <mat-form-field *ngIf="FromDate" color="accent" appearance="fill" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
        <mat-label>From</mat-label>
        <input
          matInput
          [matDatepicker]="picker1"
          (dateInput)="addEventfrom('input', $event)"
          (dateChange)="addEventfrom('change', $event)"
          [value]="date2.value"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="picker1"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>

      <mat-form-field *ngIf="ToDate" color="accent" appearance="fill" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
        <mat-label>To</mat-label>
        <input
          matInput
          [matDatepicker]="picker2"
          (dateInput)="addEventto('input', $event)"
          (dateChange)="addEventto('change', $event)"
          [value]="date.value"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="picker2"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker2 color="primary"></mat-datepicker>
      </mat-form-field>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
        <button
          mat-raised-button
          color="primary"
          style="top: 8px"
          (click)="OnSelectTypeReportsGenerated()"
        >
          Search
        </button>
      </div>
    </div>
  
  </div>
  <div class="col-md-12" *ngIf="viewTable">
    <table
      datatable
      [dtOptions]="dtoptions"
      class="table table-hover table-striped table-bordered"
      cellspacing="0"
      style="
        background: #ffffffad;
        color: black;
        font-weight: bold !important;
      "
      id="tabless"
    >
      <thead>
        <tr>
          <th *ngFor="let column of displayedColumns">{{column}}</th>
          

          
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tab of objectKeys(ArrayDataReport2)">
          <td *ngFor="let tab2 of objectKeys2(tab)">
            {{tab2}}
          </td>
      </tr>
      </tbody>
    </table>
  </div>
  
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0.07)"
  size="medium"
  color="#2879ff"
  type="square-jelly-box"
  [fullScreen]="true"
></ngx-spinner>
